import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";

import { LocationAssociate } from "@components/Location";

export default function CampaignParticipants({ campaignId, organizationId }) {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);

  const managerInfo = useSelector((state) => state.manager);
  const isOrgManager = managerInfo && managerInfo.location_id ? true : false;

  useEffect(() => {
    fetchLocations();
  }, []);

  function fetchLocations() {
    setLoading(true);
    axios
      .get(`/campaigns/${campaignId}/retrieve-locations/`)
      .then(({ data }) => {
        setLoading(false);
        setLocations(
          data.response.map((m) => ({
            ...m,
            link_url: `/locations/${m.id}`,
          }))
        );
      })
      .catch((err) => {
        setLoading(false);
        setLocations([]);
      });
  }

  const locationIds = locations.map((m) => m.id);

  return (
    <LocationAssociate
      fetchData={fetchLocations}
      campaignId={campaignId}
      disabledIds={locationIds}
      selectReqData={{
        organization_id: organizationId,
        status: 1,
      }}
      bulkData={
        isOrgManager
          ? null
          : {
              download_request_data: {
                context: "campaign_locations",
                campaign_id: campaignId,
              },
              upload_request_data: {
                campaign_id: campaignId,
                context: "add_campaign_loc",
              },
            }
      }
    />
  );
}
